import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// 1. Home Page
import HomePage from './pages/HomePage';

// 2. All 18 Sector Pages (.js)
import AshrafTextile from './pages/AshrafTextile';
import AshrafiaFood from './pages/AshrafiaFood';
import YarnDivision from './pages/YarnDivision';
import KKCarpets from './pages/KKCarpets';
import RekoSports from './pages/RekoSports';
import RHSportsArena from './pages/RHSportsArena';
import Glitz from './pages/Glitz';
import AshrafiaTechnologies from './pages/AshrafiaTechnologies';
import KKIndustries from './pages/KKIndustries';
import AshrafiaEnergy from './pages/AshrafiaEnergy';
import AshrafDistributor from './pages/AshrafDistributor';
import RHEnterprises from './pages/RHEnterprises';
import AshrafiaGoatFarm from './pages/AshrafiaGoatFarm';
import KKMats from './pages/KKMats';
import CPW3Ginum from './pages/CPW3Ginum';
import NoorUnAleaNoor from './pages/NoorUnAleaNoor';
import FaiqEnterprises from './pages/FaiqEnterprises';
import AshrafHospital from './pages/AshrafHospital';

function App() {
  return (
    <Router>
      <Routes>
        {/* Main Grid View */}
        <Route path="/" element={<HomePage />} />

        {/* 18 Individual Direct Routes */}
        <Route path="/ashraf-textile" element={<AshrafTextile />} />
        <Route path="/ashrafia-food" element={<AshrafiaFood />} />
        <Route path="/yarn-division" element={<YarnDivision />} />
        <Route path="/kk-carpets" element={<KKCarpets />} />
        <Route path="/reko-sports" element={<RekoSports />} />
        <Route path="/rh-sports-arena" element={<RHSportsArena />} />
        <Route path="/glitz" element={<Glitz />} />
        <Route path="/ashrafia-technologies" element={<AshrafiaTechnologies />} />
        <Route path="/kk-industries" element={<KKIndustries />} />
        <Route path="/ashrafia-energy" element={<AshrafiaEnergy />} />
        <Route path="/ashraf-distributor" element={<AshrafDistributor />} />
        <Route path="/rh-enterprises" element={<RHEnterprises />} />
        <Route path="/ashrafia-goat-farm" element={<AshrafiaGoatFarm />} />
        <Route path="/kk-mats" element={<KKMats />} />
        <Route path="/cpw3-ginum" element={<CPW3Ginum />} />
        <Route path="/noor-un-alea-noor" element={<NoorUnAleaNoor />} />
        <Route path="/faiq-enterprises" element={<FaiqEnterprises />} />
        <Route path="/ashraf-hospital" element={<AshrafHospital />} />

        {/* Safety Aliases with /sector/ Prefix */}
        <Route path="/sector/ashraf-textile" element={<AshrafTextile />} />
        <Route path="/sector/ashrafia-food" element={<AshrafiaFood />} />
        <Route path="/sector/yarn-division" element={<YarnDivision />} />
        <Route path="/sector/kk-carpets" element={<KKCarpets />} />
        <Route path="/sector/reko-sports" element={<RekoSports />} />
        <Route path="/sector/rh-sports-arena" element={<RHSportsArena />} />
        <Route path="/sector/glitz" element={<Glitz />} />
        <Route path="/sector/ashrafia-technologies" element={<AshrafiaTechnologies />} />
        <Route path="/sector/kk-industries" element={<KKIndustries />} />
        <Route path="/sector/ashrafia-energy" element={<AshrafiaEnergy />} />
        <Route path="/sector/ashraf-distributor" element={<AshrafDistributor />} />
        <Route path="/sector/rh-enterprises" element={<RHEnterprises />} />
        <Route path="/sector/ashrafia-goat-farm" element={<AshrafiaGoatFarm />} />
        <Route path="/sector/kk-mats" element={<KKMats />} />
        <Route path="/sector/cpw3-ginum" element={<CPW3Ginum />} />
        <Route path="/sector/noor-un-alea-noor" element={<NoorUnAleaNoor />} />
        <Route path="/sector/faiq-enterprises" element={<FaiqEnterprises />} />
        <Route path="/sector/ashraf-hospital" element={<AshrafHospital />} />
      </Routes>
    </Router>
  );
}

export default App;